import"../../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../../icon-registry.js";const o=t("flag-tt-trinidad-and-tobago",i`
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5982_15070)">
<path d="M2 6.5C2 5.39543 2.89543 4.5 4 4.5H20C21.1046 4.5 22 5.39543 22 6.5V17.5C22 18.6046 21.1046 19.5 20 19.5H4C2.89543 19.5 2 18.6046 2 17.5V6.5Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5V19.5H22V4.5H2Z" fill="#E31D1C"/>
<mask id="mask0_5982_15070" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="4" width="20" height="16">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5V19.5H22V4.5H2Z" fill="white"/>
</mask>
<g mask="url(#mask0_5982_15070)">
<path d="M20.4678 22.9262L20.1366 23.197L19.8442 22.8848L0.879169 2.63563L0.544692 2.27851L0.923451 1.96875L2.85867 0.386048L3.1898 0.115235L3.48222 0.427452L22.4473 20.6766L22.7818 21.0338L22.403 21.3435L20.4678 22.9262Z" fill="#272727" stroke="#F7FCFF" stroke-width="0.915"/>
</g>
</g>
<path d="M4 4C2.61929 4 1.5 5.11929 1.5 6.5V17.5C1.5 18.8807 2.61929 20 4 20H20C21.3807 20 22.5 18.8807 22.5 17.5V6.5C22.5 5.11929 21.3807 4 20 4H4Z" stroke="#BFBFBF"/>
<defs>
<clipPath id="clip0_5982_15070">
<path d="M2 6.5C2 5.39543 2.89543 4.5 4 4.5H20C21.1046 4.5 22 5.39543 22 6.5V17.5C22 18.6046 21.1046 19.5 20 19.5H4C2.89543 19.5 2 18.6046 2 17.5V6.5Z" fill="white"/>
</clipPath>
</defs>
</svg>

    `);export{o as FlagTtTrinidadAndTobago};
